export enum STORAGE_CONSTRAINT {
  USER_PERMISSIONS = "USER_PERMISSIONS",
  USER_PROFILE = "profileData",
  USER_AUTH = "userAuth",
  TOKEN = "token",
  REFRESH_TOKEN = "refreshToken",
  REMEMBER_TOKEN = "REMEMBER_TOKEN",
  PROFILE_DATA = "profileData",
  MIN_SIDE_NAV = "MIN_SIDE_NAV",
  APP_TYPE = "APP_TYPE",
  APP_VERSION = "DASHBOARD_1",
  NOTIFICATIONS_LIST = "NOTIFICATIONS_LIST",
  SKIPPED_UPDATING_PASSWORD = "SKIPPED_UPDATING_PASSWORD",
}
